// eslint-disable-next-line clearbit-x/no-tree-shaking-imports
import { fade } from '@material-ui/core/styles/colorManipulator';

const theme = (outerTheme) => ({
  ...outerTheme,

  palette: {
    ...outerTheme?.palette,
  },

  editorStyles: {
    primary: outerTheme.palette.blue[500],
    secondary: outerTheme.palette.blue[400],
    tertiary: outerTheme.palette.blue[300],
    border: `${fade(outerTheme.palette.blue[200], 0.4)}`,
    tint: outerTheme.palette.blue[100],
    background: outerTheme.palette.blue[0],
    shadow: `0 0 0 1px ${fade(
      outerTheme.palette.blue[200],
      0.4,
    )}, 0 1px 2px 1px rgba(0, 0, 0, .08)`,
  },
});

export default theme;
